import moment from "moment";
import { forwardRef, useRef, useState, useEffect } from "react";
import Pagination from "../../Controls/Pagination/pagination";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../StateManagement/actions";
import { useSelector, useDispatch } from "react-redux";

const PageLockerPendingReqTable = forwardRef(function PageLockerPendingReqTable(
  {
    orgPageLockerLstPendingRequestAccess,
    noRecordsFoundPendingAccess,
    language,
    dateFormatValueUpper,
    paginationAttributes,
    onPageChange,
    onNextClick,
    onPrevClick,
    onReviewClick,
    totalPages,
    selectAllPL,
    pageView,
    isClear,
    selectedOption,
    onPageViewDropDown,
    applyTimeZoneToDisplay,
    timeZoneRef,
    timeZoneAbbrevation,
    onSelectionChange
  },
  ref
) {
  const allCheckRef = useRef();
  const pageViewRef = useRef();
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(languageChange(localStorage.getItem("language")));
  }, []);

  useEffect(() => {
    if (allCheckRef.current != null) {
      allCheckRef.current.checked = selectAllPL;
    }
  }, [isClear]);

  const handlerMasterSelectionRequest = () => {
    if (allCheckRef.current.checked) {
      ref?.current?.map((element) => {
        if (element) element.checked = true;
      });
    } else {
      ref?.current?.map((element) => {
        if (element) element.checked = false;
      });
    }
    forceUpdate((prev) => !prev);
  };

  let count = 0;
  const handleSelectedAllRequest = () => {
    ref.current = ref.current.filter((r) => r !== null);
    const checkedCount = ref.current.filter(
      (element) => element.checked
    ).length;

    if (allCheckRef.current != null) {
      allCheckRef.current.checked =
        ref.current.length === checkedCount;
    }
    forceUpdate((prev) => !prev);
  };

  const PrevClick = () => {
    onPrevClick();
    orgPageLockerLstPendingRequestAccess.map(
      (element) => (element.checked = false)
    );
  };
  const NextClick = () => {
    onNextClick();
    orgPageLockerLstPendingRequestAccess.map(
      (element) => (element.checked = false)
    );
  };
  const PageChange = (i) => {
    onPageChange(i);
  };
  const setpageViewDrp = () => {
    onPageViewDropDown(pageViewRef.current.value);
  };

  // Stop the row click from bubbling up when the user clicks the checkbox
  const stopRowClick = (e) => e.stopPropagation();

  const formatPages = (pages) =>
    Array.isArray(pages) && pages.length > 0 ? pages.join(", ") : "-";

  const [isSticky, setIsSticky] = useState(false);
  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop < 135) setIsSticky(false);
    else if (scrollTop > 135) setIsSticky(true);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const selectedRows = orgPageLockerLstPendingRequestAccess.filter(
    (_, i) => ref?.current?.[i]?.checked
  );

  const groupedPages = selectedRows.map(row => {
    let pages = [];
    if (row.status === "Partially Approved" || row.status === "Approved") {
      pages = row.approvedPages || [];
    }
    else if (row.status === "Partially Declined" || row.status === "Declined") {
      pages = row.rejectedPages || [];
    }
    else {
      pages = row.pendingPages || [];
    }

    return {
      requestId: row.id,
      pages: pages
    }
  });

  useEffect(() => {
    if (typeof onSelectionChange === "function") {
      onSelectionChange(groupedPages);
    }
  }, [JSON.stringify(groupedPages)]);
  const [, forceUpdate] = useState(false);

  return (
    <div
      className="card-body p-0"
      style={{ paddingRight: "0.15rem !important" }}
    >
      <div
        className="table-responsive res-card"
        style={{ marginTop: ` ${isSticky ? "47px" : "0px"}` }}
      >
        <table
          className="fold-table table tablelayout "
          cellPadding="0"
          cellSpacing="0"
        >
          <thead
            id="sticky2"
            className={` ${isSticky
              ? "bg-lightblue sticky-fixed-accessrquest"
              : "bg-lightblue"
              }`}
            style={{ top: ` ${isSticky ? "75px" : ""}` }}
          >
            <tr className="">
              {selectedOption != language.UI_MyRequests ? (
                <th className="w-5p text-start">
                  <div className="checkbox">
                    <label className="p-0 mb-0">
                      <input
                        type="checkbox"
                        ref={allCheckRef}
                        onChange={handlerMasterSelectionRequest}
                      />
                      <span className="cr">
                        <i className="cr-icon material-icons">check</i>
                      </span>
                    </label>
                  </div>
                </th>
              ) : (
                ""
              )}
              <th className="w-5p type">{language.UI_Type}</th>
              <th className="w-12p pl-5px">{language.docID}</th>
              <th className="w-12p pl-5px">{language.subject}</th>
              <th className="w-12p pl-5px">{language.UI_DocumentName}</th>
              {selectedOption != language.UI_MyRequests ? (
                <th className="w-14p pl-5px">{language.readers}</th>
              ) : (
                ""
              )}
              {selectedOption === language.UI_MyRequests ? (
                <th className="w-14p pl-5px">
                  {selectedLanguage.LstLanguageCodes.UI_Owner}
                </th>
              ) : (
                ""
              )}
              <th className="w-10p pl-5px">{language.UI_PageNumbers}</th>
              <th className="w-12p pl-5px">{language.UI_RequestedDate}</th>
              <th className="w-9p pl-5px">{language.UI_Reason}</th>
              <th className="w-7p pl-5px">
                {selectedLanguage.LstLanguageCodes.UI_Status}
              </th>
            </tr>
          </thead>

          <tbody>
            {orgPageLockerLstPendingRequestAccess.length > 0 &&
              !noRecordsFoundPendingAccess &&
              orgPageLockerLstPendingRequestAccess.map((item, i) => (
                <tr
                  className="view"
                  key={item.id}
                  onClick={() => onReviewClick(item)}
                  style={{
                    borderBottom: "0.1rem solid #e7e5e570",
                    cursor: "pointer",
                  }}
                  id={"trMain" + i}
                >
                  {selectedOption != language.UI_MyRequests ? (
                    <td className="w-5p text-start" onClick={stopRowClick}>
                      <div className="checkbox">
                        <label className="p-0 mb-0">
                          <input
                            type="checkbox"
                            ref={(el) => (ref.current[i] = el)}
                            onChange={handleSelectedAllRequest}
                          />
                          <span className="cr">
                            <i className="cr-icon material-icons">check</i>
                          </span>
                        </label>
                      </div>
                    </td>
                  ) : (
                    ""
                  )}
                  <td
                    className="w-5p text-center"
                    style={{ borderLeft: "0.1rem solid #e7e5e570" }}
                  >
                    {item.rpdType !== undefined && item.rpdType === "Create" ? (
                      <img
                        className="create-img"
                        src="assets/img/icons/create.svg"
                        height="28px"
                      />
                    ) : (
                      <span className="material-icons top3">mail </span>
                    )}
                  </td>
                  <td
                    className="w-12p pl-5px"
                    style={{ borderLeft: "0.1rem solid #e7e5e570" }}
                    title={item.documentId}
                  >
                    <div className="d-flex flex-wrap Wordbreak">
                      <p className="textwrap mb-0">{item.documentId}</p>
                    </div>
                  </td>
                  <td
                    className="w-12p pl-5px"
                    style={{ borderLeft: "0.1rem solid #e7e5e570" }}
                    title={item.subject}
                  >
                    <div className="d-flex flex-wrap Wordbreak">
                      <p className="textwrap mb-0">{item.subject}</p>
                    </div>
                  </td>
                  <td
                    className="w-12p pl-5px"
                    style={{ borderLeft: "0.1rem solid #e7e5e570" }}
                    title={item.documentName}
                  >
                    <div className="d-flex flex-wrap Wordbreak">
                      <p className="textwrap mb-0">{item.documentName}</p>
                    </div>
                  </td>
                  {selectedOption != language.UI_MyRequests ? (
                    <td
                      className="w-14p pl-5px"
                      style={{ borderLeft: "0.1rem solid #e7e5e570" }}
                      title={item.readerEmail}
                    >
                      <div className="d-flex flex-wrap Wordbreak">
                        <p className="textwrap mb-0">
                          {item.readerEmail != null && item.readerEmail}
                        </p>
                      </div>
                    </td>
                  ) : (
                    ""
                  )}
                  {selectedOption === language.UI_MyRequests ? (
                    <td
                      className="w-14p pl-5px"
                      style={{ borderLeft: "0.1rem solid #e7e5e570" }}
                      title={item.senderEmail}
                    >
                      <div className="d-flex flex-wrap Wordbreak">
                        <p className="textwrap mb-0">
                          {item.senderEmail != null && item.senderEmail}
                        </p>
                      </div>
                    </td>
                  ) : (
                    ""
                  )}
                  <td
                    className="w-10p pl-5px flex-wrap Wordbreak"
                    style={{ borderLeft: "0.1rem solid #e7e5e570" }}
                    title={formatPages(((item.status === "Partially Approved" || item.status === "Approved") ? [...(item.approvedPages || [])].sort((a, b) => a - b)
                      : (item.status === "Partially Declined" || item.status === "Declined") ? [...(item.rejectedPages || [])].sort((a, b) => a - b) : [...((item.pendingPages || item.requestedPages) || [])].sort((a, b) => a - b))
                    )}
                  >
                    <div className="flex-wrap Wordbreak">
                      <p className="textwrap mb-0 text-ellipsis">
                        {formatPages(((item.status === "Partially Approved" || item.status === "Approved") ? [...(item.approvedPages || [])].sort((a, b) => a - b)
                          : (item.status === "Partially Declined" || item.status === "Declined") ? [...(item.rejectedPages || [])].sort((a, b) => a - b)
                            : [...((item.pendingPages || item.requestedPages) || [])].sort((a, b) => a - b))
                        )}
                      </p>
                    </div>
                  </td>
                  <td
                    className="w-12p pl-5px"
                    style={{ borderLeft: "0.1rem solid #e7e5e570" }}
                  >
                    <div className="d-flex flex-wrap textwrap">
                      {moment
                        .utc(
                          applyTimeZoneToDisplay(
                            new Date(item.createdDate),
                            timeZoneRef.current
                          )
                        )
                        .format(dateFormatValueUpper + " HH:mm")}
                    </div>
                  </td>
                  <td
                    className="w-9p pl-5px"
                    style={{ borderLeft: "0.1rem solid #e7e5e570" }}
                    title={item.readerNotes}
                  >
                    <div
                      className="d-flex flex-wrap Wordbreak"
                      title={item.readerNotes}
                    >
                      <p className="textwrap mb-0 text-ellipsis">
                        {item.readerNotes}
                      </p>
                    </div>
                  </td>
                  <td
                    className="w-7p pl-5px"
                    style={{ borderLeft: "0.1rem solid #e7e5e570" }}
                  >
                    <div className="d-flex flex-wrap">
                      {item.status === "Pending"
                        ? selectedLanguage.LstLanguageCodes.UI_Pendingtxt
                        : item.status === "Approved"
                          ? selectedLanguage.LstLanguageCodes.UI_Approvedtxt
                          : item.status === "Partially Approved"
                            ? selectedLanguage.LstLanguageCodes.UI_PartiallyApproved
                            : item.status === "Partially Declined"
                              ? selectedLanguage.LstLanguageCodes.UI_PartiallyDeclined
                              : selectedLanguage.LstLanguageCodes.UI_Declined}
                    </div>
                  </td>
                </tr>
              ))}
            {noRecordsFoundPendingAccess && (
              <tr>
                <td colSpan={11} style={{ textAlign: "center" }}>
                  {language.UI_NoRecordsFound}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="row d-flex align-items-center justify-content-between">
        <p className="w-auto ms-3">
          <label
            htmlFor="pageView"
            className="radio-label font-w600 control res-w  res-left12"
            style={{ paddingTop: "9px", paddingRight: "5px" }}
          >
            {pageView}:
          </label>
          <select
            className=""
            name="documentIdInput"
            ref={pageViewRef}
            onChange={setpageViewDrp}
          >
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </p>
        {totalPages > 1 ? (
          <Pagination
            {...paginationAttributes}
            onPrevClick={PrevClick}
            onNextClick={NextClick}
            onPageChange={(i) => PageChange(i)}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
});

export default PageLockerPendingReqTable;
